import axios from 'axios';

// export default () => {
//   const http = axios.create({
//     baseURL: window.config.serviceUrl,
//     withCredentials: false,
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${localStorage.getItem('virsis-sessionkey')}`,
//     },
//   });
export default () => {
  const http = axios.create({
    baseURL: window.config.serviceUrl,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('viddis-sessionkey')}`,
    },
  });
  return http;
};
